<div>
    <h6 style="text-transform: uppercase;">{{ 'bikeshop.modal.update_job_card.relink.title' | translate}}</h6>
</div>

<div class="row margin-top-16">
    <div class="col-md-2 label"></div>
    <div class="col-md-7">
        <div class="p-inputgroup">
            <input type="text" pInputText [(ngModel)]="search"
                   placeholder="{{ 'bikeshop.modal.shedule_service.search_customer' | translate}}"
                   (keyup.enter)="searchCyclist()"/>
            <span class="p-inputgroup-addon"><i class="fa hubtiger-search" (click)="searchCyclist()"></i></span>
        </div>
    </div>
</div>


<div class="row margin-top-16" *ngIf="cyclists && cyclists.length>0">
    <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.select_cyclist' | translate}}:</div>
    <div class="col-md-7">
        <p-dropdown [options]="cyclists" [(ngModel)]="selectedCyclist" (ngModelChange)="getBikes()">
        </p-dropdown>
    </div>
    <div class="col-md-3">
        <button pButton type="button" class="p-button-raised full-width alternate" (click)="addCyclist()"
                label="{{ 'bikeshop.modal.shedule_service.add_new_cyclist' | translate}}"></button>
    </div>
</div>
<div *ngIf="selectedCyclist && selectedCyclist.ID">
    <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'general.email' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedCyclist.Email}}
        </div>
        <div class="col-md-2 label">{{ 'general.phone_number' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedCyclist.PhoneNumber}}
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'general.firstname' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedCyclist.Name}}
        </div>
        <div class="col-md-2 label">{{ 'general.surname' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedCyclist.Surname}}
        </div>
    </div>
</div>

<div class="row margin-top-8" *ngIf="bikes && bikes.length>0">
    <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.select_bike' | translate}}:</div>
    <div class="col-md-7">
        <p-dropdown [options]="bikes" [(ngModel)]="selectedBike"></p-dropdown>
    </div>
    <div class="col-md-3">
        <button pButton type="button" class="p-button-raised full-width alternate" (click)="addBike()"
                label="{{ 'bikeshop.modal.shedule_service.add_new_bike' | translate}}"></button>
    </div>
</div>
<div *ngIf="selectedBike && selectedBike.ID">
    <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'general.manufacturer' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedBike.Manufacturer}}
        </div>
        <div class="col-md-2 label">{{ 'general.model' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedBike.Model}}
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'bikeshop.modal.shared.bike.year' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedBike.ModelYear}}
        </div>
        <div class="col-md-2 label">{{ 'general.color' | translate}}:</div>
        <div class="col-md-3 value">
            {{selectedBike.Colour}}
        </div>
    </div>
</div>
<div style="margin-top:8px;" *ngIf="!searching && cyclists && bikes && (!selectedCyclist.ID || !selectedBike.ID)">
    <div style="text-align: center; margin-bottom: 8px;" *ngIf="!addNewCyclist && cyclists.length===0">
        {{ 'bikeshop.modal.shedule_service.search_no_matches' | translate}}</div>
    <div>
        <app-cyclist-bike [partnerId]="partnerID" [user]="selectedCyclist" (update)="newCyclist($event)"
                          [email]="search">
        </app-cyclist-bike>
    </div>
</div>


<div class="row margin-top-16 footer">
    <div class="col-md-3">
        <button pButton type="button" class="p-button-raised full-width" (click)="cancelRelink()"
                label="{{ 'general.cancel' | translate}}"></button>
    </div>
    <div class="col-md-6"></div>
    <div class="col-md-3">
        <button pButton type="button" class="p-button-raised full-width" [icon]="busy ? 'pi pi-spin pi-spinner' : ''"
                iconPos="right" (click)="relinkJobCard()"
                label="{{ 'bikeshop.modal.update_job_card.relink.relink-jobcard' | translate}}"
                [disabled]="!selectedBike.ID || busy"></button>
    </div>
</div>
